import styled from 'styled-components'
import { PurchaseProcessStatus } from '@Purchasing/Domain/Model/PurchaseProcess'

// Badges do DS ODB Promo (sem verde): neutro, primary teal, ok escuro, err rosa.
const statusColors: Record<string, { background: string; color: string }> = {
    DRAFT: { background: '#EDEDED', color: '#595959' },
    ACTIVE: { background: '#58BFD6', color: '#fff' },
    LOST: { background: '#FBD8E5', color: '#AE1B52' },
    CANCELED: { background: '#FBD8E5', color: '#AE1B52' },
    FINISHED: { background: 'rgba(26, 30, 35, 0.1)', color: '#1A1E23' },
}

const getStatusColor = (status: PurchaseProcessStatus) =>
    statusColors[status] ?? statusColors.DRAFT

export const StatusTag = styled.div<{ status: PurchaseProcessStatus }>`
    display: inline-flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    background: ${({ status }) => getStatusColor(status).background};
    color: ${({ status }) => getStatusColor(status).color};
`
